// SAB-595: "Add funds and join" return path. When a user with an insufficient
// wallet balance is sent to the deposit flow to fund a paid-league join, we stash
// the target invite code so we can bring them BACK to /nfl/join/<code> after a
// successful deposit — surviving the PayPal external-browser round trip (native
// re-opens to a fresh app state, so an in-memory return path is lost; localStorage
// is not). The URL `join` param covers the web case; this is the belt-and-suspenders.
//
// Consumed on a successful DEPOSIT (WalletDeposit / NativeUrlHandler) AND cleared on
// a successful JOIN, so it can never resurface later. 1-hour TTL so an abandoned
// deposit self-expires rather than hijacking an unrelated deposit weeks later.

const KEY = 'sf_join_after_deposit';
const TTL_MS = 60 * 60 * 1000; // 1 hour

export interface PendingJoin {
  code: string;
  leagueId: string;
  ts: number;
}

export function setPendingJoin(code: string, leagueId: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, leagueId, ts: Date.now() }));
  } catch {
    /* storage unavailable (private mode / disabled) — the URL `join` param still covers web */
  }
}

export function getPendingJoin(): PendingJoin | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw) as PendingJoin;
    if (!p || typeof p.code !== 'string' || typeof p.leagueId !== 'string' || typeof p.ts !== 'number') {
      clearPendingJoin();
      return null;
    }
    if (Date.now() - p.ts > TTL_MS) {
      clearPendingJoin(); // expired
      return null;
    }
    return p;
  } catch {
    return null;
  }
}

export function clearPendingJoin(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
